<pos-app-spinner [show]="loading | async"></pos-app-spinner>
<div #scheduler_here class="dhx_cal_container panel">
  <div class="dhx_cal_navline">
    <div class="dhx_cal_prev_button">&nbsp;</div>
    <div class="dhx_cal_next_button">&nbsp;</div>
    <div class="dhx_cal_today_button"></div>
    <div class="d-flex">
       <app-custom-workshop-calendar
        [defaultBranch]="defaultBranch"
        [currentMonth]="currentMonth"
        (dateSelected)="onCalendarDateSelected($event)"
        (monthNavigated)="onCalendarMonthNavigated($event)"
        (calendarOpened)="onCalendarOpened($event)"
        [class]="'dhx_cal_date'"
      >
      </app-custom-workshop-calendar>
    </div>

    <div class="d-flex flex-grow-1 justify-content-center px-4"></div>

    <div class="d-flex flex-grow-1 justify-content-end">
      <div class="row">
        <div class="col">
          <button *ngIf="!fullScreen" class="btn text-white" (click)="legendView()">LEGEND</button>
          <div *ngIf="!fullScreen" ngbDropdown class="d-inline-block">
            <button class="btn text-white" id="dropdownBasic1" ngbDropdownToggle>RESOURCE</button>
            <div ngbDropdownMenu aria-labelledby="dropdownBasic1" class="dropdown-menu-right" style="left: -8.5rem">
              <button ngbDropdownItem (click)="handleAddResource()">ADD</button>
              <button ngbDropdownItem (click)="resourceChange()">CHANGE</button>
              <button style="margin-left: 0px" ngbDropdownItem (click)="resourceRemove()">REMOVE</button>
            </div>
          </div>
          <div *ngIf="!fullScreen" ngbDropdown class="d-inline-block">
            <button class="btn text-white" id="dropdownBasic1" ngbDropdownToggle>WORKSHOP</button>
            <div ngbDropdownMenu aria-labelledby="dropdownBasic1" class="dropdown-menu-right" style="left: -8.5rem">
              <button ngbDropdownItem (click)="setWorkshopDay()">SET DAY</button>
              <button style="margin-left: 0px" ngbDropdownItem (click)="setWorkshopHour()">SET HOURS</button>
            </div>
          </div>

          <button *ngIf="showSMS" class="btn text-white" (click)="sendSMSReminder(true, 0, '')">SEND SMS REMINDER</button>
          <div class="d-inline-block">
            <div class="d-flex justify-content-end">
              <div *ngIf="!fullScreen" (click)="openFullscreen()"><mat-icon> fullscreen </mat-icon></div>
              <div *ngIf="fullScreen" (click)="closeFullscreen()"><mat-icon> fullscreen_exit </mat-icon></div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div *ngIf="dateArray" class="w-100 d-flex justify-content-center align-items-center mb-2" style="font-size: 1rem">
    <span class="me-4"><label>TOTAL RESOURCE AVAILABLE:</label> {{ totalResourceAvailableHours | number : '1.1-1' }} hrs</span>
    <span class="me-4"><label>TOTAL RESOURCE BOOKED:</label> {{ totalResourceBookedHours | number : '1.1-1' }} hrs</span>
    <span class="me-4"><label>TOTAL RESOURCE HRS:</label> {{ totalResourceHours | number : '1.1-1' }} hrs</span>
  </div>
  <div class="dhx_cal_header"></div>
  <div class="dhx_cal_data"></div>
</div>

<p-confirmDialog header="Warning" #sendSMSConfirmation key="sendSMSConfirmation">
  <p-footer>
    <button type="button" class="btn text-white" (click)="sendSMSConfirmation.onAccept()" style="width: 80px">OK</button>
    <button type="button" class="btn btn-cancel" (click)="sendSMSConfirmation.onReject()">Cancel</button>
  </p-footer>
</p-confirmDialog>

<p-confirmDialog header="Result" #sendSMSResult key="sendSMSResult">
  <p-footer>
    <button type="button" class="btn text-white" (click)="sendSMSResult.onAccept()" style="width: 80px">OK</button>
  </p-footer>
</p-confirmDialog>

<p-confirmDialog header="Warning" #goToDateResult key="goToDateResult">
  <p-footer>
    <button type="button" class="btn text-white" (click)="goToDateResult.onAccept()" style="width: 80px">OK</button>
  </p-footer>
</p-confirmDialog>
<ng-template #content let-c="close" let-d="dismiss">
  <div>
    <div class="modal-header">
      <h4 class="modal-title">LEGEND</h4>
    </div>
    <div class="modal-body">
      <div class="d-flex justify-content-evenly flex-row">
        <div class="d-flex flex-column">
          <div *ngIf="jobTypeLegend" class="text-center">
            <label>JOB TYPE</label>
            <div *ngFor="let jobType of jobTypeLegend">
              <div *ngIf="jobType.borderOrFill === 'BORDER'" class="mb-2 p-1" [style.border]="'2px solid #' + jobType.colourCode">
                {{ jobType.longDescription }}
              </div>
              <div *ngIf="jobType.borderOrFill === 'FILL'" class="mb-2 p-1 text-white" [style.background-color]="'#' + jobType.colourCode">
                {{ jobType.longDescription }}
              </div>
            </div>
          </div>
        </div>
        <div class="d-flex flex-column">
          <div *ngIf="vehicleStatusLegend" class="text-center">
            <label>VEHICLE STATUS</label>
            <div *ngFor="let vehicleStatus of vehicleStatusLegend">
              <div *ngIf="vehicleStatus.borderOrFill === 'BORDER'" class="mb-2 p-1" [style.border]="'2px solid #' + vehicleStatus.colourCode">
                {{ vehicleStatus.longDescription }}
              </div>
              <div
                *ngIf="vehicleStatus.borderOrFill === 'FILL'"
                class="mb-2 p-1 text-white"
                [style.background-color]="'#' + vehicleStatus.colourCode"
              >
                {{ vehicleStatus.longDescription }}
              </div>
            </div>
          </div>
        </div>

        <div class="d-flex flex-column">
        <div *ngIf="vehicleStatusLegend" class="text-center">
          <label>CUSTOMER TYPE</label>
          <div *ngFor="let vehicleStatus of customerTypeLegend" style="background-color: lightgray">
            <div *ngIf="vehicleStatus.borderOrFill === 'BORDER'" class="mb-2 p-1" [style.border-top]="'2px solid #' + vehicleStatus.colourCode">
              {{ vehicleStatus.longDescription }}
            </div>
            <div *ngIf="vehicleStatus.borderOrFill === 'FILL'" class="mb-2 p-1 text-white" [style.background-color]="'#' + vehicleStatus.colourCode">
              {{ vehicleStatus.longDescription }}
            </div>
          </div>
        </div>
      </div>
        
      </div>
    </div>
    <div>
      <div class="pt-2">
        <div class="row px-2 flex-nowrap fitter-row-position position-relative"></div>
      </div>
    </div>
    <div class="modal-footer">
      <div class="col d-flex float-end justify-content-end">
        <button class="btn btn-cancel mx-1 px-2" (click)="handleCloseModal(true)">CLOSE</button>
      </div>
    </div>
  </div>
</ng-template>
